import { injectable } from '@servicetitan/react-ioc';
import { action, observable, makeObservable } from 'mobx';

@injectable()
export class TooltipsStore {
    @observable tooltips: Record<string, string | undefined> = {};

    constructor() {
        makeObservable(this);
    }

    @action
    setTooltips(tooltips: Record<string, string>) {
        this.tooltips = { ...tooltips };
    }
}
